const convertUserFromServer = (user) => (Object.assign(Object.assign({}, user), { is_active: user.is_active === "1", has_password: user.has_password === "1" }));
const convertExtendedUserFromServer = (user) => (Object.assign(Object.assign({}, user), { is_active: user.is_active === "1" }));
export { convertExtendedUserFromServer, convertUserFromServer };
